import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const topCustomersXS = [
    {
        dataField: 'xs',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                    <TableRowField label='Apellidos:' value={row.lastname} />
                    <TableRowField label='Email:' value={row.email} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.totalbought)} />
                </div>
            )
        }
    }
]

export const topCustomersSM = [
    {
        dataField: 'sm',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                    <TableRowField label='Apellidos:' value={row.lastname} />
                </div>
            )
        }
    },
    {
        dataField: 'email',
        text: 'Email'
    },
    {
        dataField: 'totalbought',
        text: 'Total (S/)',
        formatter: (cell) => {
            return <span>{formatHelper.toMoney(cell)}</span>
        }
    }
]

export const topCustomers = [
    {
        dataField: 'name',
        text: 'Nombre'
    },
    {
        dataField: 'lastname',
        text: 'Apellidos'
    },
    {
        dataField: 'email',
        text: 'Email'
    },
    {
        dataField: 'totalbought',
        text: 'Total (S/)',
        formatter: (cell) => {
            return <span>{formatHelper.toMoney(cell)}</span>
        }
    }
]


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopCustomer/_columns.js